module.exports = __webpack_public_path__ + "img/medical_record_download.c21428ed.svg";